"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


/** Checks if a value is an array, if not, returns the value wrapped in one */
var returnArray = exports.returnArray = function returnArray(value) {
  return Array.isArray(value) ? value : [value];
};


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/utils/array.js
// module id = 362
// module chunks = 114276838955818